export default function Marketing360() {
  const pillars = [
    {
      title: 'Estratégia',
      description: 'Planejamento baseado em dados e objetivos de negócio',
      icon: 'ri-lightbulb-line',
      delay: 'animation-delay-100'
    },
    {
      title: 'Aquisição',
      description: 'Atração qualificada através de múltiplos canais',
      icon: 'ri-user-add-line',
      delay: 'animation-delay-200'
    },
    {
      title: 'Conversão',
      description: 'Otimização de funil e experiência do usuário',
      icon: 'ri-arrow-right-up-line',
      delay: 'animation-delay-300'
    },
    {
      title: 'Análise',
      description: 'Monitoramento contínuo e ajustes estratégicos',
      icon: 'ri-bar-chart-2-line',
      delay: 'animation-delay-400'
    }
  ];

  return (
    <section className="py-16 sm:py-20 md:py-24 px-4 sm:px-6 bg-gradient-to-b from-gray-50 to-white overflow-hidden">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
            O que realmente significa Marketing 360
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto mb-3 sm:mb-4">
            Marketing 360 é a integração entre estratégia, aquisição, conversão e análise, com foco em crescimento sustentável e mensurável.
          </p>
          <p className="text-base sm:text-lg md:text-xl text-teal-700 font-semibold">
            Não trabalhamos com ações isoladas. Trabalhamos com sistemas de crescimento.
          </p>
        </div>

        {/* Central 360 Circle */}
        <div className="relative flex items-center justify-center mb-12 sm:mb-16 md:mb-20">
          <div className="relative w-32 h-32 sm:w-40 sm:h-40 md:w-48 md:h-48">
            {/* Rotating border */}
            <div className="absolute inset-0 rounded-full border-4 border-teal-200 animate-spin-slow"></div>
            
            {/* Inner circle */}
            <div className="absolute inset-2 sm:inset-3 rounded-full bg-gradient-to-br from-teal-600 to-teal-700 flex items-center justify-center shadow-2xl animate-pulse-slow">
              <span className="text-3xl sm:text-4xl md:text-5xl font-bold text-white">360°</span>
            </div>

            {/* Connecting lines */}
            <div className="absolute top-1/2 left-1/2 w-[200%] sm:w-[250%] h-0.5 bg-gradient-to-r from-transparent via-teal-300 to-transparent -translate-x-1/2 -translate-y-1/2"></div>
            <div className="absolute top-1/2 left-1/2 w-0.5 h-[200%] sm:h-[250%] bg-gradient-to-b from-transparent via-teal-300 to-transparent -translate-x-1/2 -translate-y-1/2"></div>
          </div>
        </div>

        {/* Pillars Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {pillars.map((pillar, index) => (
            <div
              key={index}
              className={`bg-white p-6 sm:p-8 rounded-xl border-2 border-gray-100 hover:border-teal-500 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 animate-fade-in-up ${pillar.delay}`}
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6">
                <i className={`${pillar.icon} text-xl sm:text-2xl text-teal-600`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                {pillar.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                {pillar.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes spin-slow {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        
        @keyframes pulse-slow {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
        
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-spin-slow {
          animation: spin-slow 8s linear infinite;
        }
        
        .animate-pulse-slow {
          animation: pulse-slow 3s ease-in-out infinite;
        }
        
        .animate-fade-in-up {
          animation: fade-in-up 0.6s ease-out forwards;
        }
        
        .animation-delay-100 {
          animation-delay: 0.1s;
        }
        
        .animation-delay-200 {
          animation-delay: 0.2s;
        }
        
        .animation-delay-300 {
          animation-delay: 0.3s;
        }
        
        .animation-delay-400 {
          animation-delay: 0.4s;
        }
      `}</style>
    </section>
  );
}
